require('bootstrap');
window.$ = window.jQuery = require('jquery');
require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('select2');
require('@majidh1/jalalidatepicker/dist/jalalidatepicker.min');
require('datatables.net-dt/js/dataTables.dataTables.min')
// require('jquery/src/jquery')
